<section class="h-full flex flex-col gap-2 z-0 relative overflow-y-auto  p-2 lg:pl-0">
    <div
        class="max-w-6xl p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg">
        <form [formGroup]="userProfileForm">
            <div class="flex justify-between">
                <div>
                    <h1 class="heading">
                        Profile
                    </h1>
                </div>
                <div class="flex gap-6 items-center">
                    <div *ngIf="user && user.fundingsource && user.fundingsource.title" class="bg-[#f2f2f3] border border-dashed border-[#09090b4f] p-[5px] rounded-[5px] text-[12px]">
                        <p>FS : {{user.fundingsource.title}}</p>
                    </div>
                    <button class="btn btn-secondary" (click)="resetPassword()">Reset Password</button>
                </div>
            </div>
            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
            <section class="grid gap-4 sm:grid-cols-2">
                <div class="space-y-1">
                    <label class="subheading">
                        Name
                    </label>
                    <div>
                        <div>
                            <input formControlName="name" type="text" readonly />
                        </div>

                    </div>
                </div>
                <div class="space-y-1">
                    <label class="subheading">
                        Email
                    </label>
                    <div>
                        <div>
                            <input formControlName="email" type="email" readonly />
                        </div>

                    </div>
                </div>
                <div class="col-span-full space-y-1">
                    <label class="subheading">
                        Profile Image
                    </label>
                    <div class="flex flex-1 gap-2">
                        <div class="flex-1">
                            <div class="relative overflow-hidden rounded-full inline-flex mt-1">
                                <!-- Display the profile logo or a placeholder -->
                                <img src="{{profileImageURL ? profileImageURL : 'assets/images/profileImagePlaceholder.png'}}"
                                    alt="Profile Image"
                                    class="relative h-32 w-32 rounded-full border border-main-base" />
                                <label for="Profile"
                                    class="absolute inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-75 text-sm font-medium text-white opacity-0 focus-within:opacity-100 hover:opacity-100">
                                    <span>Change</span>
                                    <input #logoInput type="file" accept="image/*" style="width: 100%;" [hidden]="true"
                                        (change)="processFile(logoInput)" type="file" id="Profile" name="Profile Image"
                                        class="absolute inset-0 h-full w-full cursor-pointer rounded-md border-main-base opacity-0" />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                
            </section>
        </form>
    </div>
</section>